<template>
  <div class="section-hero sectionBackGround">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-2">
          <card class="border-0 text-left" hover shadow body-classes="py-3" style="margin-top: 20px;">
            <div class="row row-cols-2 row-cols-lg-5 g-2 g-lg-3">
              <div class="col-4 col-md-12">
                <label>会员中心</label>
              </div>
              <div class="col-4 col-md-12" style="background-color: #f0f0f0;">
                <a class="nav-link" href="#/PersonalDataList?searchQuery=2" style="height: 35px;">
                  <ul style="margin-left: -28px;">
                    <li><label>个人资料</label></li>
                  </ul>
                </a>
              </div>
              <div class="col-4 col-md-12">
                <a class="nav-link" href="" style="height: 35px;">
                  <ul style="margin-left: -28px;">
                    <li><label>我的收藏</label></li>
                  </ul>
                </a>
              </div>
              <div class="col-4 col-md-12">
                <a class="nav-link" href="#" style="height: 35px;">
                  <ul style="margin-left: -28px;">
                    <li><label>退出登录</label></li>
                  </ul>
                </a>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-10">
          <card style="margin-top: 20px;">
            <hr class="divider" />
            <form @submit.prevent="handlePasswordReset">
              <div class="row">
                <div class="col-md-6">
                  <label style="color: #000;">原密码</label>
                  <div class="form-group">
                    <div class="input-group input-group-alternative mb-4">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-single-02"></i></span>
                      </div>
                      <input v-model="oldPassword" type="password" class="form-control form-control-alternative" placeholder="原密码" required>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label style="color: #000;">新密码</label>
                  <div class="form-group">
                    <div class="input-group input-group-alternative mb-4">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-single-02"></i></span>
                      </div>
                      <input v-model="newPassword" type="password" class="form-control form-control-alternative" placeholder="新密码" required>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label style="color: #000;">确认新密码</label>
                  <div class="form-group">
                    <div class="input-group input-group-alternative mb-4">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-single-02"></i></span>
                      </div>
                      <input v-model="confirmPassword" type="password" class="form-control form-control-alternative" placeholder="确认新密码" required>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <base-button @click="handlePasswordReset" class="btn btn-success btn-lg btn-block">保存</base-button>
                </div>
                <div class="col-md-3">
                  <base-button type="button" @click="cancelReset" class="btn btn-secondary btn-lg btn-block">取消</base-button>
                </div>
              </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "DocQueryList",
  created() {
      this.username = this.getCookie('username');
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    };
  },
methods: {
  async handlePasswordReset() {
   // console.log("handlePasswordReset triggered"); // 调试输出
    const token = this.getCookie('token');  // 获取 token

    if (!token) {
      alert("Token not found, please login");
      this.$router.push('/login');
      return;
    }

    if (this.newPassword !== this.confirmPassword) {
      alert("新密码和确认密码不一致");
      return;
    }

    try {
      // 使用 URL 编码格式
      const params = new URLSearchParams();
      params.append('action', 'reset_password');
      params.append('username', this.username); // 替换为实际用户名
      params.append('oldPassword', this.oldPassword);
      params.append('newPassword', this.newPassword);
      params.append('token', token);  // 附加 token 参数

      const response = await axios.post('https://anthromindxx.com/ca.php?action=reset_password', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      if (response.data.success) {
        alert("密码修改成功");
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.logout();  // 调用 logout 方法进行注销并跳转

      } else {
        alert(response.data.message || "密码修改失败");
      }
    } catch (error) {
     // console.error("Error:", error);
      alert("请求失败，请稍后重试");
    }
  },
  cancelReset() {
    this.oldPassword = '';
    this.newPassword = '';
    this.confirmPassword = '';
  },
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },
  logout() {
      // 清除 token 和 username 的 cookie
      this.clearCookie('token');
      this.clearCookie('username');
      // 清除本地存储的用户名，确保界面更新
      this.username = '';  // 清空保存的用户名
      this.$router.push('/');  // 跳转到主页
      window.location.reload();
  }
  
}
};
</script>

<style scoped>
.sectionBackGround {
  /* 使内容区域填充剩余空间 */
  min-height: calc(100vh - 48px);
  /* 确保内容区域至少与视口高度减去头部高度一样大 */
  background-image: url('https://anthromindxx.com/ant/bj.jpeg');
  /* 设置背景图路径 */
  background-position: center center;
  /* 背景图片位置 */
  background-attachment: fixed;
  /* 背景图片相对于视口固定 */
  background-size: 100% 100%;
  /* 背景图片根据元素大小缩放 */
  overflow-y: auto;
  /* 在内容较多时显示滚动条 */
  overflow: auto;
}

/* 当屏幕尺寸小于某个值时，为元素添加滚动条 */
@media (max-width: 600px) {
  .sectionBackGround {
    height: 300px;
    /* 设置一个固定高度或者最大高度 */
    overflow-y: scroll;
    /* 仅在垂直方向上显示滚动条 */
  }
}

.search-icon {
  color: #0ff5c8;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}


.pagination-controls {
  margin-top: 20px;
  margin-bottom: 20px;
}


.divider {
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin-top: 5px;
}

.div1 {
  align-self: stretch;
  position: relative;
  letter-spacing: 2px;
  line-height: 20px;
}

.child {
  width: 600px;
  position: relative;
  height: 4px;
}

.div {
  width: 100%;
  position: relative;
  height: 65px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  text-align: left;
  font-size: 14px;
  color: rgba(51, 51, 51, 0.6);
  font-family: 'Noto Sans S Chinese';
}
</style>